import { useEffect } from "react";
import { AcknowledgementDetails, requestAcknowledgements } from "@/services";
import { useRequestState } from "@/hooks";

export const useAcknowledgements = (
  EmpId: number | undefined,
  ApplicationId: number | undefined,
  ActionId: number | undefined,
) => {
  const {
    data: acknowledgements,
    setSuccess,
    setError,
  } = useRequestState<AcknowledgementDetails[]>({ isLoading: true });

  useEffect(() => {
    if (ActionId && EmpId && ApplicationId) {
      const controller = new AbortController();

      requestAcknowledgements(
        {
          EmpId,
          ApplicationId,
          ActionId,
        },
        {
          signal: controller.signal,
        },
      ).then(data => {
        if (data.Success) {
          setSuccess(data.Data);
        } else if (data.Code === 404) {
          setSuccess(
            data.Message.map(message => ({
              ApplicationActionId: 0,
              AcknowledgementDescEn: message,
              AcknowledgementDescAr: "",
              AcknowledgementName: "",
            })),
          );
        }
      });
    }
  }, [ActionId, EmpId, ApplicationId, setSuccess, setError]);

  return { acknowledgements };
};
